<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <slot />
    </v-layout>
  </v-container>
</template>

<script>
export default {};
</script>

<style scoped lang="less">
@import "../assets/global.less";
</style>
